import * as z from "zod/v4";

export const saveContextualPixelConfig = {
  name: "saveContextualPixelConfig" as const,
  input: z.object({ gtmContainerId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
